module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-fullheight"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-4 has-text-centered"
  }, [_vm._v("Please, authorize")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-4"
  }, [_c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.login($event)
      },
      "input": _vm.clearError
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.username),
      expression: "credentials.username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-medium': true, 'is-danger': _vm.veeErrors.has('username')
    },
    attrs: {
      "name": "username",
      "type": "email",
      "placeholder": "Enter your email"
    },
    domProps: {
      "value": (_vm.credentials.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('username')),
      expression: "veeErrors.has('username')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('username')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-medium': true, 'is-danger': _vm.veeErrors.has('password')
    },
    attrs: {
      "name": "password",
      "placeholder": "Enter your password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('password')),
      expression: "veeErrors.has('password')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('password')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [(_vm.error) ? _c('span', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped is-grouped-centered"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-dark",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hero-foot"
  }, [_c('div', {
    staticClass: "container has-text-centered has-text-grey"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "is-size-7"
  }, [_vm._v(_vm._s(_vm.year) + " ©")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "is-size-7"
  }, [_vm._v("Fusion Console by "), _c('a', {
    attrs: {
      "href": "https://fusionnextinc.com/"
    }
  }, [_vm._v("Fusion Next Inc.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22c54358"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 333
// module chunks = 1